module.exports = __webpack_public_path__ + "static/img/team_si_bg.e8b68e0f.png";